define(["require", "exports", "jquery", "knockout", "./dateUtils"], function (require, exports, $, ko, dateUtils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    ko.bindingHandlers.boolText = {
        update: function (element, valueAccessor, allBindingsAccessor) {
            var value = ko.utils.unwrapObservable(valueAccessor());
            if (value === true || value.toString().toLowerCase() === "true") {
                //TODO need to do localized in the future
                ko.bindingHandlers.text.update(element, function () { return "Yes"; }, null, null, null);
            }
            else {
                ko.bindingHandlers.text.update(element, function () { return "No"; }, null, null, null);
            }
        }
    };
    ko.bindingHandlers.rootClick = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var newValueAccessor = function () {
                var result = {};
                result['click'] = valueAccessor().bind(bindingContext.$root);
                return result;
            };
            // Standard knockout event handler:
            return ko.bindingHandlers['event']['init'].call(this, element, newValueAccessor, allBindings, viewModel, bindingContext);
        }
    };
    ko.bindingHandlers.onEnterKey = {
        init: function (element, valueAccessor, allBindings, viewModel) {
            var callback = valueAccessor();
            $(element).keypress(function (event) {
                var keyCode = (event.which ? event.which : event.keyCode);
                if (keyCode === 13) {
                    callback.call(viewModel);
                    return false;
                }
                return true;
            });
        }
    };
    ko.bindingHandlers.kendoDatePicker = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var value = valueAccessor();
            var valueUnwrapped = ko.unwrap(value);
            var binding = allBindings();
            var datePickerOptions = binding.datePickerOptions || { value: valueUnwrapped ? dateUtils.stripTime(valueUnwrapped) : null };
            datePickerOptions.change = function () {
                var datePicker = this;
                var selectedDate = datePicker.value();
                var inputVal = $(element).val();
                var required = $(element).attr('required');
                if (selectedDate) {
                    selectedDate = dateUtils.stripTime(selectedDate);
                }
                else {
                    if (inputVal || required) {
                        datePicker.value(value());
                        selectedDate = dateUtils.stripTime(datePicker.value());
                    }
                }
                // Update model value:
                value(selectedDate);
            };
            $(element).kendoDatePicker(datePickerOptions);
        },
        update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var valueUnwrapped = ko.unwrap(valueAccessor());
            var datePicker = $(element).data('kendoDatePicker');
            if (valueUnwrapped) {
                valueUnwrapped = dateUtils.stripTime(valueUnwrapped);
            }
            if (!valueUnwrapped) {
                $(element).val('');
            }
            // Exit if value is the same:
            if (valueUnwrapped == datePicker.value()) {
                return;
            }
            datePicker.value(valueUnwrapped);
        }
    };
    //todo ko.validation.makeBindingHandlerValidatable("kendoDatePicker");
    ko.bindingHandlers.kendoCalendar = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var value = valueAccessor();
            var valueUnwrapped = ko.unwrap(value);
            var binding = allBindings();
            var datePickerOptions = binding.datePickerOptions || { value: valueUnwrapped ? dateUtils.stripTime(valueUnwrapped) : null };
            datePickerOptions.change = function () {
                var datePicker = this;
                var selectedDate = datePicker.value();
                var inputVal = $(element).val();
                var required = $(element).attr('required');
                if (selectedDate) {
                    selectedDate = dateUtils.stripTime(selectedDate);
                }
                else {
                    if (inputVal || required) {
                        datePicker.value(value());
                        selectedDate = dateUtils.stripTime(datePicker.value());
                    }
                }
                // Update model value:
                value(selectedDate);
            };
            $(element).kendoCalendar(datePickerOptions);
        },
        update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var valueUnwrapped = ko.unwrap(valueAccessor());
            var datePicker = $(element).data('kendoCalendar');
            if (valueUnwrapped) {
                valueUnwrapped = dateUtils.stripTime(valueUnwrapped);
            }
            if (!valueUnwrapped) {
                $(element).val('');
            }
            // Exit if value is the same:
            if (valueUnwrapped == datePicker.value()) {
                return;
            }
            datePicker.value(valueUnwrapped);
        }
    };
});
//todo ko.validation.makeBindingHandlerValidatable("kendoCalendar");
//# sourceMappingURL=knockout.bindings.js.map


//////////////////
// WEBPACK FOOTER
// ./build/utils/knockout.bindings.js
// module id = 153
// module chunks = 2